import "./App.css";
import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import {
  PATH_CHECKOUT,
  PATH_PRODUCT,
  PATH_CATEGORY,
  PATH_BRAND,
  PATH_PAYMENT,
  PATH_THANKYOU,
  PATH_PAYMENT_INFO,
  PATH_PRODUCT_TYPE,
  PATH_ORDER_MANAGEMENT,
  PATH_ORDER_AMENDMENT,
  PATH_ORDER_REVIEW,
  PATH_USER_DETAIL_EDIT,
  PATH_STORE_SELECTION,
  PATH_INVENTORY,
} from "./constants/Paths";
import {
  Main,
  CheckoutScreen,
  PaymentScreen,
  ProductScreen,
  CategoryScreen,
  BrandScreen,
  ThankYouScreen,
  PaymentInfoScreen,
  ProductTypeScreen,
  OrderManagementScreen,
  OrderAmendmentScreen,
  OrderReviewScreen,
  UserDetailEditScreen,
  StoreSelectionScreen,
  InventoryScreen,
} from "./screens/Store";
import { useTelegram } from "./hooks/useTelegram";
import TelegramText from "./components/kit/Text/TelegramText";
import { AlertProvider } from "./components/providers/AlertProvider";
import { ModalProvider } from "./components/providers/ModalProvider";
import ErrorBoundary from "./components/providers/ErrorBoundary";
import { setupSessionInterceptors } from "./utils/sessionInvalidationHandler";
import { checkAndClearCacheIfNeeded, getCacheStatus } from "./utils/cacheInvalidation";

function App() {
  const { webApp } = useTelegram();
  const queryId = webApp.initDataUnsafe?.query_id;

  // Set up session invalidation interceptors and check for cache invalidation on mount
  useEffect(() => {
    setupSessionInterceptors();

    // Check if app version changed and clear caches if needed
    const cacheCleared = checkAndClearCacheIfNeeded();

    if (cacheCleared) {
      console.log('[App] Cache cleared due to version change');
    }

    // Log cache status for debugging
    const cacheStatus = getCacheStatus();
    console.log('[App] Cache status:', cacheStatus);
  }, []);

  return (
    <>
      {queryId ? (
        <div className="App">
          <ErrorBoundary fallbackPath="/">
            <ModalProvider>
              <AlertProvider>
                <Routes>
                <Route index element={<Main />} />
                <Route
                  path={PATH_STORE_SELECTION}
                  element={<StoreSelectionScreen />}
                />
                <Route
                  path={PATH_PRODUCT_TYPE}
                  element={<ProductTypeScreen />}
                />
                <Route path={PATH_CATEGORY} element={<CategoryScreen />} />
                <Route path={PATH_BRAND} element={<BrandScreen />} />
                <Route path={PATH_PRODUCT} element={<ProductScreen />} />
                <Route path={PATH_CHECKOUT} element={<CheckoutScreen />} />
                <Route path={PATH_PAYMENT} element={<PaymentScreen />} />
                <Route
                  path={PATH_PAYMENT_INFO}
                  element={<PaymentInfoScreen />}
                />
                <Route path={PATH_THANKYOU} element={<ThankYouScreen />} />
                <Route
                  path={PATH_ORDER_MANAGEMENT}
                  element={<OrderManagementScreen />}
                />
                <Route
                  path={PATH_ORDER_AMENDMENT}
                  element={<OrderAmendmentScreen />}
                />
                <Route
                  path={PATH_ORDER_REVIEW}
                  element={<OrderReviewScreen />}
                />
                <Route
                  path={PATH_USER_DETAIL_EDIT}
                  element={<UserDetailEditScreen />}
                />
                <Route
                  path={PATH_INVENTORY}
                  element={<InventoryScreen />}
                />
                </Routes>
              </AlertProvider>
            </ModalProvider>
          </ErrorBoundary>
        </div>
      ) : (
        <TelegramText className={`centered-text`}>
          Unauthorized 403
        </TelegramText>
      )}
    </>
  );
}

export default App;
